/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from './..\\server\\defs.defs.js'

const $nsid = 'com.atproto.admin.defs'

type $nsid = typeof $nsid

export { $nsid }

type RepoRef = { $type?: 'com.atproto.admin.defs#repoRef'; did: l.DidString }

export type { RepoRef }

const repoRef = /*#__PURE__*/ l.typedObject<RepoRef>(
  $nsid,
  'repoRef',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repoRef }

type StatusAttr = {
  $type?: 'com.atproto.admin.defs#statusAttr'
  ref?: string
  applied: boolean
}

export type { StatusAttr }

const statusAttr = /*#__PURE__*/ l.typedObject<StatusAttr>(
  $nsid,
  'statusAttr',
  /*#__PURE__*/ l.object({
    ref: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    applied: /*#__PURE__*/ l.boolean(),
  }),
)

export { statusAttr }

type AccountView = {
  $type?: 'com.atproto.admin.defs#accountView'
  did: l.DidString
  email?: string
  handle: l.HandleString
  invites?: ServerDefs.InviteCode[]
  indexedAt: l.DatetimeString
  invitedBy?: ServerDefs.InviteCode
  inviteNote?: string
  deactivatedAt?: l.DatetimeString
  relatedRecords?: l.LexMap[]
  invitesDisabled?: boolean
  emailConfirmedAt?: l.DatetimeString
  threatSignatures?: ThreatSignature[]
}

export type { AccountView }

const accountView = /*#__PURE__*/ l.typedObject<AccountView>(
  $nsid,
  'accountView',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    invites: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
          (() => ServerDefs.inviteCode) as any,
        ),
      ),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    relatedRecords: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    ),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    emailConfirmedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ThreatSignature>((() => threatSignature) as any),
      ),
    ),
  }),
)

export { accountView }

type RepoBlobRef = {
  $type?: 'com.atproto.admin.defs#repoBlobRef'
  cid: l.CidString
  did: l.DidString
  recordUri?: l.AtUriString
}

export type { RepoBlobRef }

const repoBlobRef = /*#__PURE__*/ l.typedObject<RepoBlobRef>(
  $nsid,
  'repoBlobRef',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    recordUri: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { repoBlobRef }

type ThreatSignature = {
  $type?: 'com.atproto.admin.defs#threatSignature'
  value: string
  property: string
}

export type { ThreatSignature }

const threatSignature = /*#__PURE__*/ l.typedObject<ThreatSignature>(
  $nsid,
  'threatSignature',
  /*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.string(),
    property: /*#__PURE__*/ l.string(),
  }),
)

export { threatSignature }
